import { Observable, combineLatest } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { Loader } from './loader.class';

export class StoreLoader extends Loader {
	isLoading$: Observable<boolean> = combineLatest(
		this._isLoading$,
		this._count.pipe(map(count => count > 0)),
		(loadingStore, loadingInternal) => loadingStore || loadingInternal
	)
		// setTimeout because we're not in an Angular component
		.pipe(tap(state => setTimeout(() => (this.combinedIsLoading = state))));

	error$: Observable<string | null> = combineLatest(
		this._error$,
		this._errorMessage,
		(errorStore, errorInternal) => errorStore || errorInternal
	)
		// setTimeout because we're not in an Angular component
		.pipe(tap(state => setTimeout(() => (this.combinederror = state))));

	neitherLoadingNorError: Observable<boolean> = combineLatest(this.isLoading$, this.error$, (r, l) => !(r || !!l));

	private combinedIsLoading: boolean;
	private combinederror: string | null;

	get isLoading(): boolean {
		return this.combinedIsLoading;
	}

	get errorMessage(): string {
		return this.combinederror;
	}

	constructor(public _isLoading$: Observable<boolean>, public _error$: Observable<string | null>, autoStart: boolean = false) {
		super(autoStart);
	}
}
